import { DomainHit, FilterState } from './types';
import { applyFiltersAndSort } from './selectors';

/**
 * Legacy wrapper - use applyFiltersAndSort from selectors.ts instead
 * @deprecated
 */
export const applyFilters = (
  domainMap: Map<string, DomainHit>,
  filters: FilterState,
  totalQueries: number
): DomainHit[] => {
  return applyFiltersAndSort(domainMap, filters, totalQueries);
};
